export function getCurrentMultTableFactor(level: string, activityType: number | undefined): number {
  const levelId = parseInt(level, 10)

  if ((levelId === 2 && activityType === 1) || (levelId === 2 && activityType === 2)) {
    return 1
  } else if ((levelId === 2 && activityType === 3) || (levelId === 2 && activityType === 4)) {
    return 10
  } else {
    return levelId - 1
  }
}
